import {useCallback} from 'react';
import sdk from '@/sdk';
import {curUserCanAuthorizeRead} from '@/store/util';
import toast, {ToastType} from '@/components/Toast';
import {DocRole} from '@/Constant';

export const useCanAuthorizeRead = () => {
    return useCallback(async (repository: Repository, docGuid: string, userGuid: string) => {
        const ksServer = await sdk.getKsServer(repository);
        const readable = await ksServer.getUserRole(docGuid, userGuid);

        return curUserCanAuthorizeRead() && !readable;
    }, []);
};

export const useAuthorizeRead = () => {
    return useCallback(async (
        repository: Repository,
        docGuid: string,
        members: any[],
        roleName: typeof DocRole.Member | typeof DocRole.Reader) => {
        let result = true;

        const name = members[0].nickname as string;
        try {
            const ksServer = await sdk.getKsServer(repository);
            await ksServer.inviteJoin(docGuid, {
                action: 'invite',
                roleName,
                members,
            });

            toast({
                content: name + '授权成功',
                type: ToastType.Success,
            });
        } catch (error) {
            result = false;
            toast({
                content: name + '授权失败',
                type: ToastType.Error,
            });
        }

        return result;
    }, []);
};
